<template>
  <HeaderTrade />

     <!-- Container Start { -->
     <div id="container" class="sts-trade-container">
       <!-- Contents Start { -->
       <div id="contents">

         <TradeTopNav 
          :pid="route.params.id"
         />
         
         <!-- content start -->
         <div class="contents-area">

           <!-- 체결 / 손익 start -->
           <div class="trade-result-area" id="tradeResultArea">

             <div class="trade-result-tab fm-top-tab">
               <div class="fm-tab-list">
                 <!-- tab button -->
                <ul class="nav nav-tabs" id="tradeResultTabButton" role="tablist"  @click="onResultTabList">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="trade-result-position-tab" data-bs-toggle="tab" data-bs-target="#tradeResultPositionTab" type="button" role="tab" aria-controls="tradeResultPositionTab" aria-selected="false">
                    포지션
                    <span>({{currentAssetList.length}})</span>
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="trade-result-close-tab" data-bs-toggle="tab" data-bs-target="#tradeResultCloseTab" type="button" role="tab" aria-controls="tradeResultCloseTab" aria-selected="false" @click="onClosePolTap">
                    마감손익
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="trade-result-outstanding-tab" data-bs-toggle="tab" data-bs-target="#tradeResultOutstandingTab" type="button" role="tab" aria-controls="tradeResultOutstandingTab" aria-selected="false">
                    미체결 주문
                    <span>({{currentOrderList.length}})</span>
                    </button>
                </li>                              
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="trade-result-hold-Tab" data-bs-toggle="tab" data-bs-target="#tradeResultHoldTab" type="button" role="tab" aria-controls="tradeResultHoldTab" aria-selected="true"  @click="onOrderHistory">
                    주문내역
                    </button>
                </li>
                </ul>

               </div>

               <!-- tab contents -->
               <div class="tab-content" id="tradeResultTabContents"> 
                 
                 <!-- 포지션 start -->
                 <div class="tab-pane fade show active" id="tradeResultPositionTab" role="tabpanel" aria-labelledby="trade-result-position-tab">                 
                  <div class="trade-bottom-null" v-if="currentAssetList && currentAssetList.length == 0">보유포지션이 없습니다.</div>

                    <div class="trade-result-list">                            
                      <div
                        class="result-list-inner"
                        v-for="AssetItem  in currentAssetList"
                        :key = AssetItem.ID                             
                      >
                        <div class="inner-head coinf">
                          <div class="left" @click="onClickedItemName(AssetItem)">
                            <p class="txt" :class="getLongShortColor(AssetItem.TRADETYPE)">
                              {{AssetItem.NAME}}
                            </p>
                            <span class="unit">
                              <strong>Isolated {{ AssetItem.LEVERAGE?parseInt(AssetItem.LEVERAGE):'1'}}x</strong>
                            </span>
                          </div>
                          <div class="right">
                            <div>
                              <span class="txt">진입가(USDT) :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.PRICE, getNdotpos(AssetItem.CODE)))}}                                
                              </span>
                            </div>
                            <div>
                              <span class="txt">수량 :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Number(AssetItem.COUNT))}}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">주문금액(USDT)</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(Number(AssetItem.PRICE)*Number(AssetItem.COUNT), 4))}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">강제 청산 가격(USDT)</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.LQPRICE, getNdotpos(AssetItem.CODE)))}}</span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">포지션 증거금(USDT)</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.ASSET_MARGIN, 2))}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">미실현 손익(%)</span>
                                <span class="num" :class="getCssColor(AssetItem._unrealizedPL)">
                                  {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem._unrealizedPL, 2))}}
                                  <span class="ml-1">({{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem._unrealizedPLPer, 2))+ '%'}})</span>
                                </span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">실현손익(USDT)</span>
                                <span class="num" :class="getCssColor(Number(AssetItem.TPOL))">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.TPOL, 2))}}</span>
                              </div>
                              <div class="list-txt">
                                <span class="txt">청산</span>
                                <span class="num"><button type="button" class="btn btn-sm btn-dark"  @click="onFositionOut_M(AssetItem)">시장가 정리</button></span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">공유하기</span>
                                <div class="bth-share"><button type="button" class="btn" @click="cpModal(AssetItem)"><img src="@/assets/images/trade/ico_share.png" alt="공유하기"></button></div>
                              </div>
                              <div class="list-txt">
                              </div>
                            </li>                             
                          </ul>
                        </div>

                      </div>
                    </div>

                 </div>
                 <!-- 포지션 end -->
            
                <!-- 마감손익 start -->
                 <div class="tab-pane fade" id="tradeResultCloseTab" role="tabpanel" aria-labelledby="trade-result-close-tab">
                   <div class="trade-bottom-null" v-if="closedTradeList && closedTradeList.length == 0">거래내역이 없습니다.</div>

                    <div class="trade-result-list">
                      <div
                        class="result-list-inner"
                        v-for="CloseItem  in closedTradeList"
                        :key = CloseItem.ID                       
                      >
                        <div class="inner-head coinf">
                          <div class="left">
                            <p class="txt" :class="getLongShortColor(CloseItem.TRADETYPE)">
                              {{CloseItem.NAME}}
                            </p>
                            <span class="unit">
                              <strong>Isolated {{ CloseItem.LEVERAGE?parseInt(CloseItem.LEVERAGE):'1' }}x</strong>
                            </span>                            
                          </div>
                          <div class="right">
                            <div>
                              <span class="txt">진입가(USDT) :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(CloseItem.ASSETINDEX, getNdotpos(CloseItem.CODE)))}}
                              </span>
                            </div>
                            <div>
                              <span class="txt">수량 :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Number(CloseItem.TRADECOUNT))}}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">청산가(USDT)</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(CloseItem.TRADEINDEX, getNdotpos(CloseItem.CODE)))}}</span>
                              </div>                              
                              <div class="list-txt">
                                <span class="txt">마감손익(USDT)</span>
                                <span class="num" :class="getCssColor(Number(CloseItem.TPOL))">
                                  {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(CloseItem.TPOL, 4))}}
                                </span>
                              </div>                              
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">거래 타입</span>
                                <span class="num">{{CloseItem.TRADETYPE=='5'?'롱 주문':'숏 주문'}}</span>
                              </div>                              
                              <div class="list-txt">
                                <span class="txt">주문 종료 타입</span>
                                <span class="num">{{CloseItem.CALL == 'C'?'거래':'청산'}}</span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">거래 시간</span>
                                <span class="num fs-13">{{getChangeDateStr(CloseItem.RESULTDATE)}}</span>
                              </div>
                              <!-- <div class="list-txt">
                                <span class="txt">주문 종료 타입</span>
                                <span class="num"><button type="button" class="btn btn-sm btn-danger"  @click="onOrderCancleModal(orderItem)">주문취소</button></span>
                              </div> -->
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
<!-- 
                   <perfect-scrollbar 
                       @ps-scroll-y="onScroll" 
                     
                       ref="scrollbar"
                       class="trade-result-tbl"
                   >
                     <table class="table">
                       <colgroup>
                         <col style="width:50px">
                         <col style="width:100px">
                         <col style="width:50px">
                         <col style="width:80px">
                         <col style="width:80px">
                         <col style="width:120px">
                         <col style="width:120px">
                         <col style="width:120px">
                       </colgroup>
                       <thead>
                         <tr> 
                            <th>계약</th>
                            <th>수량</th>
                            <th>진입가(USDT)</th>
                            <th>거래 타입</th>
                            <th>청산가(USDT)</th>
                            <th>마감손익(USDT)</th>
                            <th>주문 종료 타입</th>
                            <th>거래 시간</th>
                         </tr>                          
                       </thead>
                       <tbody>
                                
                            <tr
                                v-for="CloseItem  in closedTradeList"
                                :key = CloseItem.ID 
                            >
                                <td>
                                <span :class="getLongShortColor(CloseItem.TRADETYPE)">
                                    <span>{{CloseItem.NAME}}</span><br>
                                    <strong>Isolated {{ CloseItem.LEVERAGE?parseInt(CloseItem.LEVERAGE):'1' }}x</strong>
                                </span>
                                </td>
                                <td>{{Constant.UTIL.numberWithCommas(Number(CloseItem.TRADECOUNT))}}</td>
                                <td>{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(CloseItem.ASSETINDEX, getNdotpos(CloseItem.CODE)))}}</td>
                                <td>{{CloseItem.TRADETYPE=='5'?'롱 주문':'숏 주문'}}</td>
                                <td>{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(CloseItem.TRADEINDEX, getNdotpos(CloseItem.CODE)))}}</td>
                                <td :class="getCssColor(Number(CloseItem.TPOL))">
                                <span class="close-result-price">
                                {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(CloseItem.TPOL, 4))}}
                                </span>
                                <button type="button" class="btn btn-sm btn-outline-dark btn-coinf" data-bs-toggle="modal" data-bs-target="#modalShareCapture">공유</button>
                                </td>
                                <td>{{CloseItem.CALL == 'C'?'거래':'청산'}}</td>
                                <td>                      
                                {{getChangeDateStr(CloseItem.RESULTDATE)}}
                                </td>
                            </tr>
                       </tbody>
                     </table>
                   </perfect-scrollbar> -->
             
        
                 </div>
                 <!-- 마감손익 end -->
                

                <!-- 미체결 주문 start -->
                 <div class="tab-pane fade" id="tradeResultOutstandingTab" role="tabpanel" aria-labelledby="trade-result-outstanding-tab">
                   <div class="trade-bottom-null" v-if="currentOrderList && currentOrderList.length==0">미체결 주문이 없습니다.</div>


                    <div class="trade-result-list">
                      <div
                        class="result-list-inner"
                        v-for="OrderItem  in currentOrderList"
                        :key = OrderItem.ID                    
                      >
                        <div class="inner-head coinf">
                          <div class="left" @click="onClickedItemName(OrderItem)">
                            <p class="txt" :class="getLongShortColor(OrderItem.TRADETYPE)">
                              {{OrderItem.NAME}}
                            </p>
                            <span class="unit">
                              <strong>Isolated  {{ OrderItem.LEVERAGE?parseInt(OrderItem.LEVERAGE):'1'}}x</strong>
                            </span>                            
                          </div>
                          <div class="right">
                            <div>
                              <span class="txt">주문가(USDT) :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(OrderItem.ORDERINDEX, parseInt(OrderItem.NDOTPOS)))}}
                              </span>
                            </div>
                            <div>
                              <span class="txt">수량 :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Number(OrderItem.REMAINCOUNT))}}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">주문 총량</span>
                                <span class="num">{{Constant.UTIL.numberWithCommas(Number(OrderItem.ORDERCOUNT))}}</span>
                              </div>                              
                              <div class="list-txt">
                                <span class="txt">주문 타입</span>
                                <span class="num">{{OrderItem.ORDERTYPE == 'L'?'지정가':'시장가'}}</span>
                              </div>                              
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">거래 타입</span>
                                <span class="num">{{OrderItem.TRADETYPE == '3'?'롱 주문':'숏 주문'}}</span>
                              </div>                              
                              <div class="list-txt">
                                <span class="txt">거래 시간</span>
                                <span class="num fs-13">{{OrderItem.CREATIONDATE}}</span>
                              </div>
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">주문 취소</span>
                                <span class="num"><button type="button" class="btn btn-sm btn-danger" @click="onOrderCancleModal(OrderItem)">취소</button></span>
                              </div>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                          
                 </div>
                  <!-- 미체결 주문 end -->            
 
               
                <!-- 주문내역 start -->
                <div class="tab-pane fade" id="tradeResultHoldTab" role="tabpanel" aria-labelledby="trade-result-hold-tab">  
                   <div class="trade-bottom-null" v-if="allTradeList && allTradeList.length==0">주문내역이 없습니다.</div>

                    <div class="trade-result-list">
                      <div
                        class="result-list-inner"
                        v-for="TradeItem  in allTradeList"
                        :key = TradeItem.ID                 
                      >
                        <div class="inner-head coinf">
                          <div class="left">
                            <p class="txt" :class="getLongShortColor(TradeItem.TRADETYPE)">
                              {{TradeItem.NAME}}
                            </p>
                            <span class="unit">
                              <strong>Isolated {{ TradeItem.LEVERAGE?parseInt(TradeItem.LEVERAGE):'1' }}x</strong>
                            </span>                            
                          </div>
                          <div class="right">
                            <div>
                              <span class="txt">가격(USDT) :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(TradeItem.TRADEINDEX, parseInt(getNdotpos(TradeItem.CODE))))}}
                              </span>
                            </div>
                            <div>
                              <span class="txt">수량 :</span>
                              <span class="num">
                                {{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(TradeItem.ORDERCOUNT, 4))}}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="inner-body">
                          <ul class="body-list">
                            <li>
                              <div class="list-txt">
                                <span class="txt">날짜</span>
                                <span class="num fs-13">{{getChangeDateStr(TradeItem.ORDERDATE)}}</span>
                              </div>                              
                              <div class="list-txt">
                                <span class="txt">구분</span>
                                <span class="num">
                                  {{getTradeType(TradeItem.TRADETYPE, TradeItem.CALL)}}                             
                                </span>
                              </div>                              
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">주문타입</span>
                                <span class="num">{{TradeItem.ORDERTYPE == 'L'?'지정가':'시장가'}}</span>
                              </div>                              
                              <div class="list-txt">
                                <span class="txt">수수료(USDT)</span>
                                <span class="num">{{TradeItem.FEES?Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(TradeItem.FEES, 3)):'-'}}</span>
                              </div>                              
                            </li>
                            <li>
                              <div class="list-txt">
                                <span class="txt">상태</span>
                                <span class="num">{{getTradeStatus(TradeItem.STATUS)}}</span>
                              </div>                              
                              <div class="list-txt">
                                <span class="txt">실현손익(USDT)</span>
                                <span class="num" :class="TradeItem.STATUS == '2'?getCssColor(Number(TradeItem.TPOL)):''">
                                  <i></i>{{TradeItem.STATUS == '2'?Math.abs(TradeItem.TPOL):'-'}}
                                </span>
                              </div>
                            </li>
                            <li v-if="TradeItem.TRADETYPE=='5' || TradeItem.TRADETYPE=='6'">
                              <div class="list-txt">
                                <span class="txt">공유하기</span>
                                <div class="bth-share"><button type="button" class="btn" @click="cpModalSell(TradeItem)"><img src="@/assets/images/trade/ico_share.png" alt="공유하기"></button></div>
                              </div>
                              <div class="list-txt">
                              </div>
                            </li>                             
                          </ul>
                        </div>

                      </div>
                    </div>

                </div>
                <!-- 주문내역 end -->

              </div>                 
             </div>

           </div>
           <!-- //체결 / 손익 end -->

         </div>
         <!-- // content end -->

         <TradeBottomNav
           :id="route.params.id"
          />

       </div>
       <!-- } Contents End -->
     </div>
     <!-- } Container End -->


    <BasicModal2b
      v-if="showModal2"
      @close="closeModal2" 
      @cancle="closeModal2" 
      @ok="onModalOk2" 
      :titleTxt="txtTitle_alert2"
      :bodyTxt="txtBody_alert2"
    />

    <BasicModal2b
      v-if="showModal"
      @close="closeModal" 
      @cancle="closeModal" 
      @ok="onModalOk" 
      :titleTxt="txtTitle_alert"
      :bodyTxt="txtBody_alert"
    />

    <CaptureModal
      v-if="showModal3" 
      @close="closeModal3" 
      @cancle="closeModal3" 
      @ok="okModal3" 
      :assetData="currentAssetItem"
    />

    <CaptureModalSell
      v-if="showModal4" 
      @close="closeModal4" 
      @cancle="closeModal4" 
      @ok="okModal4" 
      :assetData="currentOrderHistoryItem"
    />    

</template>

<script>

import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeTopNav from "@/components/TradeTopNav.vue"
import TradeBottomNav from "@/components/TradeBottomNav.vue"
import {useRouter , useRoute}from 'vue-router'
// import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import { computed, onMounted, onUnmounted, getCurrentInstance, ref, watch} from 'vue';
import axios from '@/axios';
//import { useToast } from '@/composables/toast';
import BasicModal2b from '@/components/popups/BasicModal2b.vue';

import Constant from '@/constant.js';
import {useApicall} from '@/composables/commonFn';
import moment from 'moment';
import { useScoket } from '@/socket';
import {useBalance, useGetItemList} from '@/composables/vtradeFn';
import CaptureModal from '@/components/popups/CaptureModal.vue';
import CaptureModalSell from '@/components/popups/CaptureModalSell.vue';
import { event } from 'vue-gtag'

export default {
   components:{   
       HeaderTrade,
       TradeTopNav,
       TradeBottomNav,
      //  PerfectScrollbar,
       BasicModal2b,
       CaptureModal,
       CaptureModalSell
   },
   setup(){
   // const {socket} = useScoket();
     const store = useStore();
     const memberData = computed(()=> store.state.user.memberData)
     const route = useRoute();
     const router = useRouter();
     const {socket} = useScoket(); 
     store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0'); 
     store.commit('trade/CHANGE_CURRENT_PAGE_BOTTOM', 'tradeResult'); 
     const {setCurrentBalance} = useBalance(); 
     var items = null;
     const selectItem = ref(null)

     const onResultTabList = (e) => {
       var btn = e.target;
       btn.scrollIntoView({behavior: "smooth" ,inline: "center"});
     }

    const  {getItemListBySessionStorage} = useGetItemList()

      // const {         
      //               triggerToast
      //       } = useToast();
  
      const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
     // const periodInitDataKeep = computed(()=>store.state.hts.periodInitDataKeep);
      const currentTradeType = computed(()=> store.state.hts.currentTradeType);
      const currentOrderList = computed(()=> store.state.hts.orderList);
      const currentAssetList = computed(()=> store.state.hts.assetlist);
      
      const {apiCall_gt} = useApicall()
      // setTimeout(()=>{
      //  console.log("currentOrderList:", currentOrderList.value.length, currentOrderList.value)
      //  console.log("currentAssetList:", currentAssetList.value)
      // },3000)
      
     // const leverageDatas= ref({}) 
      //console.log( )
      const txtTitle_alert = ref("시장가 정리");
      const txtBody_alert = ref("시장가로 포지션 종료를 원하시면 아래 확인 버튼을 눌러주세요.")

      const  {getItemByCode} = useGetItemList()
      const txtTitle_alert2 = ref("주문 확인");
      const txtBody_alert2 = ref("주문을 취소 하시겠습니까?")
     
     
      const allTrade = computed(()=> store.state.hts.allTrade);
      const showModal = ref(false);        
      const showModal2 = ref(false); 
      const showModal3 = ref(false);
      const showModal4 = ref(false);

      const  currentAssetItem = ref({})
      const  currentOrderHistoryItem = ref({})


      var intervalId;

      const allTradeList = ref([])
      const closedTradeList = ref([]);
      const dailyProfitData = ref({});

      var orderCancleItem = null;    
      var selectFositionOutAssetData = null;

      const applySpaceList = computed(()=> store.state.hts.applySpaceList);
      const getIsApplySpace = (spaceId) =>{
          var  found =    applySpaceList.value.find(element => element.SPACE_ID == spaceId);          
          if(found)
          {
            return true;
          }
          else
          {
            return false;
          }
      }

      if(route.params.id == '0')
      {
        store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'normal');
      }
      else
      {
        store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'event');
      }

      const onClickedItemName = (item) =>{
        var t_item = items.find(element => element.CODE ==  item.CODE);             
        //  emit('onSelectItem', t_item);   
        sessionStorage.setItem(`startItem_${currentTradeType.value}`, JSON.stringify(t_item)); 
        router.push({
            name: 'TradeArea',
            params: {
              code:t_item.CODE,
              id:route.params.id                        
            }
        }) 
       //  console.log("onClickedItemName", t_item)
      }

      onUnmounted(()=>{
        //  console.log("onUnmounted~~~~~~~~~~~2222")          
          store.dispatch('hts/leaveAssetItems');
          clearInterval(intervalId);
      })
           
      onMounted( async ()=>{
       // console.log("getIsApplySpace:~~~~~~~~~~~~~~~~")
        items = await getItemListBySessionStorage(currentTradeType.value)
        //  console.log("onMounted~~~~~~~~~~~2222")
        store.commit('hts/CHANGE_ASSETLIST',[]);
        store.commit('hts/CHANGE_ORDERLIST', []);


        if(store.state.hts.currentSpaceId != null &&  store.state.hts.currentSpaceId != -1 )
        {
                setCurrentBalance(store.state.hts.currentSpaceId); 
       
        }       

        selectItem.value = await getItemByCode(currentTradeType.value, route.params.code) 
        store.commit('hts/CHANGE_CURRENT_ITEM', selectItem.value);


        setTimeout(()=>{
            var isApply = getIsApplySpace(store.state.hts.currentSpaceId);


            if(isApply)
            {
               getOrderList()
               getAssetList()
            //  store.dispatch('hts/getOrderList');
            //  store.dispatch('hts/getAssetList'); 
            }
            else
            {              
              store.commit('hts/CHANGE_ASSETLIST',[]);
              store.commit('hts/CHANGE_TOTAL_POL',{}); 
              store.commit('hts/CHANGE_ORDERLIST', []);
            }     
      

        }, 1000)

        clearInterval(intervalId);
        intervalId = setInterval(()=>{
            var totalProfit = 0;
            // var totalPrice = 0;
            for(var i=0; i<currentAssetList.value.length ; i++)
            {
                if(currentAssetList.value[i])
                {
                    totalProfit += Number(currentAssetList.value[i]._unrealizedPL);
                    //totalProfit += Number(currentAssetList.value[i]._unrealizedPL) *Number(currentAssetList.value[i].COUNT);
                    //totalPrice += (Number(currentAssetList.value[i].PRICE) + Number(currentAssetList.value[i]._unrealizedPL))  *Number(currentAssetList.value[i].COUNT);                           
                }  
            }
            //console.log("onMounted111:", totalProfit, "totalPrice:", totalPrice )
            // store.commit('hts/CHANGE_TOTAL_PRICE',totalPrice); 
            store.commit('hts/CHANGE_TOTAL_PROFIT',totalProfit); 
        },1000)      
     
          
      })


      const getOrderList = async () => {   

        if(store.state.hts.currentSpaceId == null)return;
        var token = sessionStorage.getItem('token');  
        try{            
            const  res = await axios.get(`vspace/getorderlist?spaceId=${store.state.hts.currentSpaceId}`, {
                headers: {
                    'token': token
                }
            });   
            
            let json =  res.data;   
            if (json.returnCode == 1) {
                if (json.resultMap.returnVal == 1) {  
                  
                    if(!json.resultMap.dataList) json.resultMap.dataList = [];
                    store.commit('hts/CHANGE_ORDERLIST', json.resultMap.dataList);
                    
                    if(json.resultMap.dataList.length > 0)
                    {
                        json.resultMap.dataList.forEach(element =>
                        {
                            element.checked =  false;                           
                        } );
                    }                   
                } else {                    
                    store.commit('hts/CHANGE_ORDERLIST', []);
                    console.log(json.message);
                }
            }
            else if(json.returnCode == -102 )
            {
                console.log("로그인이 필요합니다.");
            }
            else
            {            
                  console.log(json.message);
            }               
        }catch(error){            
            console.log(error);
        }  
      }



      const getAssetList = async () => { 
            if(store.state.hts.currentSpaceId == null)return;
            var token = sessionStorage.getItem('token');
            try{
                const  res = await axios.get(`vspace/getassetlist?spaceId=${store.state.hts.currentSpaceId }`, {
                    headers: {
                        'token': token
                   }
                });   
                let json =  res.data;   
                if (json.returnCode == 1) {
                    if (json.resultMap.returnVal == 1) { 
                        if(!json.resultMap.dataList) json.resultMap.dataList = [];
                         store.commit('hts/CHANGE_ASSETLIST', json.resultMap.dataList);
                         store.commit('hts/CHANGE_TOTAL_POL', json.resultMap.dataSum);
                      
                        if(json.resultMap.dataList.length > 0)
                        {
                            json.resultMap.dataList.forEach(element =>
                            {
                                element.checked =  false;                           
                            } );
                        }                                  
 
                       
                       requesAssetItems()
                    } else {
                         store.commit('hts/CHANGE_ASSETLIST', []);       
                    }
                }
                else if(json.returnCode == -102 )
                {
                    console.log("로그인이 필요합니다.");
                }
                else
                {               
                  console.log(json.message);
                }               
            }catch(error){             
                console.log(error);
            }  
        } 

        const requesAssetItems =  () => { 
            
            var isNight = false;
            if(store.state.hts.currentItem && store.state.hts.currentItem.isNight) isNight = true;   
            var assetInitArr = []
            setTimeout(()=>{
                for(let i=0; i<store.state.hts.assetlist.length; i++)
                {
                    var item = store.state.hts.assetlist[i];                   
                    var assetInitData = 
                    { "drate" :  "0" , 
                      "trade_price" : Number(item.CURRENT),
                      "code": item.CODE,
                      "price": Number(item.CURRENT)
                    }

                    if(item.KIND == "S" || item.KIND == "C" || item.KIND == "G" )
                    {
                      assetInitData.itemType = item.KIND;
                    }
                    else
                    {
                      assetInitData.itemType = 'F';                           
                    }

                    
                    assetInitArr.push(assetInitData);     
                    socket.emit("requestTrade", {
                        itemType:store.state.hts.currentTradeType,
                        code: item.CODE,
                        isNight:isNight  
                    }, function() {       
                        // console.log("connect socket requestTrade~111",state.currentTradeType, item.CODE ) 
                    })
                }

                for(let ii=0; ii<assetInitArr.length; ii++)
                {
                    // console.log("aaaaaa~", assetInitArr ) 
                    setTimeout(()=>{
                        store.commit('hts/CHANGE_ALL_TEADE', assetInitArr.shift()) 
                    }, ii * 200)                    
                }
            },1500)
        }

        const getTradeType = (type, _call) =>{
            switch(type)
            {
                case '3':
                    return "롱 포지션 진입"                        
                case '4':
                    return "숏 포지션 진입"                       
                case '5':
                    return _call == 'C'?'롱 포지션 정리':'롱 포지션 정리(청산발동)'                        
                case '6':
                    return  _call == 'C'?'숏 포지션 정리':'숏 포지션 정리(청산발동)'
            }
        }

        const getTradeStatus = (type) =>{
            switch(type)
            {
                case '1':
                    return "신규"                        
                case '2':
                    return "체결"                       
                case '8':
                    return "거부"                        
                case '9':
                    return "취소"
            }
        }




      watch(allTrade, ()=>{   
          var  tradeItem = allTrade.value;   
          const found_long =  currentAssetList.value.find(element => element.CODE ==  tradeItem.code  && element.TRADETYPE == '3' ); 
          const found_short =  currentAssetList.value.find(element => element.CODE ==  tradeItem.code  && element.TRADETYPE == '4'); 
          var unrealizedPL; 
          var unrealizedPLPer; 
          var realizedPL; 
          var feeVal;

          if(found_long)
          {
                feeVal = Number(found_long.PRICE) *  Number(found_long.COUNT) * (Number(found_long.FEES)/100);
                unrealizedPL = (Number(tradeItem.price) - Number(found_long.PRICE)) * Number(found_long.COUNT);  
                unrealizedPLPer = unrealizedPL / (Number(found_long.ASSET_MARGIN) + feeVal) * 100;
               // realizedPL =   unrealizedPL - feeVal; 
                realizedPL =   -feeVal; 
               // console.log("unrealizedPL:", unrealizedPL, feeVal)
                found_long._unrealizedPLPer = unrealizedPLPer;
                found_long._unrealizedPL = unrealizedPL;
                found_long._realizedPL = realizedPL;

                found_long.COLOR_CLASS = getCssColor(realizedPL);       

          }

          if(found_short)
          {
                feeVal = Number(found_short.PRICE) *  Number(found_short.COUNT) * (Number(found_short.FEES)/100);
                unrealizedPL = (Number(found_short.PRICE) - Number(tradeItem.price)) * Number(found_short.COUNT);  
                unrealizedPLPer = unrealizedPL / (Number(found_short.ASSET_MARGIN) + feeVal) * 100;
                //realizedPL =   unrealizedPL - feeVal;       
                realizedPL =  -feeVal; 
                found_short._unrealizedPLPer = unrealizedPLPer;
                found_short._unrealizedPL = unrealizedPL;
                found_short._realizedPL = realizedPL;

                found_short.COLOR_CLASS = getCssColor(realizedPL);              
          }
      })


      const getCssColor = (num) => {
          var result = ''
          if(num > 0)
          {
              result = "up" 
          }
          else if(num < 0)
          {
              result = "down"         
          }
          else
          {
              result = ""      
          } 
          return result;
      }



   
    const onDailyProfitList = async()=>{
       // var dateStr = moment(new Date()).format('YYYY-MM-DD');        
       //console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^", store.state.hts.)
        var res = await apiCall_gt(`vspace/getprofitlistbyday?type=${currentTradeType.value}&spaceId=${store.state.hts.currentSpaceId}`);
        dailyProfitData.value = res.dataList;
        
        var prevSumPol = null;
        for(let i= dailyProfitData.value.length -1 ; i>=0; i-- )
        {
          var _data = dailyProfitData.value[i];
          if(prevSumPol)
          {
            if(currentTradeType.value == 'F' )
            {
                _data._sumProfit = prevSumPol +  Number(_data.KF_TPOL) + Number(_data.FF_TPOL);
            }
            else
            {
                 _data._sumProfit = prevSumPol +  Number(_data.BUY_TPOL) + Number(_data.SELL_TPOL);
            }
            
          }
          else
          {
            if(currentTradeType.value == 'F' )
            {
                 _data._sumProfit = Number(_data.KF_TPOL) + Number(_data.FF_TPOL);
            }
            else
            {
               _data._sumProfit = Number(_data.BUY_TPOL) + Number(_data.SELL_TPOL);
            }             
          }         
          prevSumPol = _data._sumProfit;
        }
      }

      const onDailyTradeList = async()=>{
       
        var res = await apiCall_gt(`vspace/gettradelist?type=${currentTradeType.value}&spaceId=${store.state.hts.currentSpaceId}&status=2`);        
       if(res &&  res.dataList )
       {            
            closedTradeList.value = []; 
            allTradeList.value =  res.dataList;
            res.dataList.forEach(element => {
                  if(element.STATUS == '2'){
                      if(element.TRADETYPE == '5' || element.TRADETYPE == '6')
                      {
                        closedTradeList.value.push(element);                   
                      }
                  }
            });
       }       
      }


      


     const onAssetSellSelected = ()=>{
          showModal.value = true;
     }
     const onOrderCencelSelected = ()=>{
          showModal2.value = true;
     }


     const closeModal =()=>{
        showModal.value = false;
        selectFositionOutAssetData = null;
     }

    const closeModal2 =()=>{
        showModal2.value = false;
        orderCancleItem = null;
     }

 
    const onModalOk = async()=>{
        showModal.value = false;
        var token = sessionStorage.getItem('token');   

         var params = {
              spaceId: selectFositionOutAssetData.SPACE_ID,
              type: 'G',
              orderType:'M',
              tradeType : selectFositionOutAssetData.TRADETYPE == '3'?'5':'6',
              code:selectFositionOutAssetData.CODE,                        
              count:selectFositionOutAssetData.COUNT,                                         
          } 

          try{
                const res = await axios.post('vspace/orderregister', params ,{
                    headers: {
                            'token': token,                    
                    }
                });   
                let json =  res.data;                     
                if (json.returnCode == 1) {
                
                    if (json.resultMap.returnVal == 1) {  
                      //  triggerToast('주문이 완료되었습니다.');                           
                        store.dispatch('hts/getAssetList')   
                        setTimeout(()=>{
                              emitter.emit('EVENT_UPDATE_AVAILABLE_COUNT');
                        },1000)

                        var gtag_type = null;
                        if(params.tradeType == '5')
                        {
                          gtag_type = 'long_out'
                        }
                        else if(params.tradeType == '6')
                        {
                          gtag_type = 'short_out'
                        }

                      event( 'coinFutures_tranding', { 'ID': memberData.value.MID, 'transaction_type': gtag_type, 'time': moment(new Date()).format('YYYYMMDD HH:mm:ss')});
                      window.fbq('trackCustom', 'coinFutures_tranding', {'ID':  memberData.value.MID,  'transaction_type': gtag_type,'time': moment(new Date()).format('YYYYMMDD HH:mm:ss') });
                      console.log("event~ :", 'coinFutures_tranding', memberData.value.MID , gtag_type,  moment(new Date()).format('YYYYMMDD HH:mm:ss'));
                      

                    } else {
                        emitter.emit('EVENT_ALERT',{title:"알림", body:json.message});     
                        //triggerToast(json.message, 'danger');                        
                        
                    }
                }
                else if(json.returnCode == -102 )
                {
                    alert("로그인이 필요합니다.");
                }
                else
                {
                  //triggerToast(json.message, 'danger');                     
                }              
          }catch(error){
              //triggerToast('Something went wrong!', 'danger');
              console.log(error);
          } 
     }


   const onOrderCancleModal = (item)=>{
       showModal2.value = true;
       orderCancleItem = item;
   }

    const onOrderCancle = async ()=>{
       showModal2.value = false;
       
      var token = sessionStorage.getItem('token'); 
      var params = {                            
                          type:  currentTradeType.value,
                          orderId:orderCancleItem.ID,       
                    } 
          try{
            
              const res = await axios.post('vspace/ordercancel', params ,{
                  headers: {
                          'token': token,                    
                  }
              });   
              let json =  res.data;                     
              if (json.returnCode == 1) {
              
                  if (json.resultMap.returnVal == 1) {  
                      //triggerToast('주문이 취소가 완료되었습니다.'); 
                      store.dispatch('hts/getOrderList');      
                      setTimeout(()=>{
                            emitter.emit('EVENT_UPDATE_AVAILABLE_COUNT');
                      },1000)
                  } else {
                     // triggerToast(json.message, 'danger'); 
                      emitter.emit('EVENT_ALERT',{title:"알림", body:json.message});                            
                      
                  }
              }
              else if(json.returnCode == -102 )
              {
                  alert("로그인이 필요합니다.");
              }
              else
              {
                //triggerToast(json.message, 'danger');                     
              } 
              
              orderCancleItem = null;
          }catch(error){
              //triggerToast('Something went wrong!', 'danger');
              console.log(error);
          } 
    }

    const onScroll = (e) =>{
          e
          // trace(e.target.scrollTop); 
      }

     const onModalOk2 = ()=>{
            showModal2.value = false;
            if(orderCancleItem)
            {
               onOrderCancle()
            } 

     }
   
      const onFositionOut_M = (item) =>{
        //  console.log(item.TRADETYPE)
          showModal.value = true;
          selectFositionOutAssetData = item;        
      }

      const getNdotpos = (_code) =>{
        var result = 0
        if(items && items.length > 0)
        {
            var found = items.find(element => element.CODE ==  _code); 
            if(found && found.NDOTPOS )
            {
              result = parseInt(found.NDOTPOS);
            }
        }
       // console.log("getNdotpos ", _code , result, store.state.hts.currentItemDatas)
        return result;
      }

      const getleverage = async(_code)=>{       
          var result = 0;           
          if(!store.state.hts.currentAccountId || store.state.hts.currentAccountId == null)return 0; 
          var res = await apiCall_gt(`vspace/getleverage?accountId=${store.state.hts.currentAccountId}&code=${_code}`);     
          if(res)
          {
            
            result = parseInt(res.data.L_LEVERAGE);         
          }  
        //  console.log("result",res  )
          return result 
     }



      
    const getLongShortColor=(_tradeType)=>{ 
      var result = '' 
      if(_tradeType == '3' || _tradeType == '5')
      {
            result = 'long'
      }
      else if(_tradeType == '4' || _tradeType == '6')
      {
           result = 'short'
      }
       
      return result;
     }

    

    const getChangeDateStr=(str)=>{  
       return moment(str, "YYYYMMDDhhmmss").format("YYYY-MM-DD HH:mm:ss");
     }

    const onClosePolTap = () =>{
           onDailyTradeList();
    }

    const onOrderHistory = () =>{
       onDailyTradeList()
    }

    const cpModal = (item) => {
      currentAssetItem.value = item
      showModal3.value = true; 
    }

    const okModal3 = () => {
      showModal3.value = false; 
    }

    const closeModal3 = () => {
      showModal3.value = false; 
    }        

    const cpModalSell = (item) => {
      currentOrderHistoryItem.value = item;
      showModal4.value = true; 
    }

    const okModal4 = () => {
      showModal4.value = false; 
    }

    const closeModal4 = () => {
      showModal4.value = false; 
    }   
     return{
          options: {       
                wheelSpeed: 1,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollX: true,
          },
          watcher: true,
          currentOrderList,
          currentAssetList,
          Constant,
          getTradeType,
        
         // periodInitDataKeep,
         
      
          onAssetSellSelected,
          closeModal,
          onModalOk,
          showModal,
          txtTitle_alert,
          txtBody_alert,
          showModal2,
          txtTitle_alert2,
          txtBody_alert2,
          closeModal2,
          onModalOk2,
          onOrderCencelSelected,
          onOrderCancleModal,
          currentTradeType,
       
          closedTradeList,
          onScroll,
          onDailyProfitList,
          dailyProfitData,
          getChangeDateStr,
          onClickedItemName,
          getleverage,
          onFositionOut_M,
          getNdotpos,
         // leverageDatas,
          allTradeList,
          getTradeStatus,
          getLongShortColor,
          getCssColor,
          onClosePolTap,
          onOrderHistory,
          onResultTabList,
          cpModal,
          showModal3,
          closeModal3,
          okModal3, 
          currentAssetItem,
          cpModalSell,
          currentOrderHistoryItem,
          showModal4,
          closeModal4,
          okModal4,   
          route
         
     }
   }
}
</script>

<style>

</style>